import { tv } from "../../variants/tv.js";
const baseAutocompleteVariants = tv({
    slots: {
        rootSlot: 'relative flex flex-col gap-1',
        overlayInputSlot: 'relative mt-1 grid w-full grid-cols-[48px_1fr] gap-3 px-4 pb-4',
        popupSlot: 'max-h-[370px] w-[var(--anchor-width)] min-w-[464px] origin-[var(--transform-origin)] overflow-x-hidden overflow-y-auto overscroll-contain rounded-xl bg-neutral-1 shadow-lg transition-[transform,scale,opacity] outline-none data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0',
        positionerSlot: 'z-1 rounded-xl bg-neutral-1 transition-opacity duration-150 data-[closed]:opacity-0',
        listSlot: 'flex flex-col gap-0 p-1',
        emptySlot: 'flex h-16 items-center justify-center px-4 py-2 text-primary-11',
        groupLabelSlot: 'text-sm h-8 pt-2 pb-1 pl-3 font-medium text-primary-13',
        iconSlot: 'flex items-center justify-center'
    },
    variants: {
        isMobile: {
            true: {
                popupSlot: 'h-full max-h-none w-full shadow-none'
            }
        }
    }
});
export { baseAutocompleteVariants };
